import HeadingLargeSummary from './HeadingLargeSummary';
export default HeadingLargeSummary;
//# sourceMappingURL=index.js.map